export const uk = {
    'search-input-text': 'Знайти',
    'video-stock-search-input-text': 'Поиск видео'
};
